// extracted by mini-css-extract-plugin
module.exports = {"title__main":"Title-module--title__main--2_Kcf","title__main-link":"Title-module--title__main-link--3rllI"};